<div class="w-full bg-white">
    <div class="w-full block header_modal">
        <ng-container *ngIf="data.title; else elseTitle">
            <h1 class="text-center text-[color:var(--primary-color)]" mat-dialog-title>{{ data.title }}</h1>
        </ng-container>
        <ng-template #elseTitle>
            <img src="/assets/img/qhantuy/logo.png" alt="QH Organizaciones" class="w-[200px] block mx-auto max-w-full">
        </ng-template>
    </div>
    
    <div class="w-full grid grid-cols-[100%] gap-4 content_modal" [ngClass]="{'bg-[rgba(246,247,249,1)]': data.alert}">
        <p *ngIf="data.description" class="m-0 text-base font-medium text-gray-500">{{ data.description }}</p>
        <div class="grid grid-cols-[100%] gap-4" [ngClass]="{'gap-0': data.alert}">
            <div *ngIf="data.content" class="content__wrapper bg-white rounded-2xl p-6" [innerHtml]="data.content" [ngClass]="{'rounded-b-none': data.alert}"></div>
            <div *ngIf="data.note" class="content__wrapper bg-gray-200 rounded-2xl p-5 {{ data.note && 'note' }}" [innerHtml]="data.note" [ngClass]="{'rounded-t-none': data.alert}"></div>
        </div>
        <mat-form-field *ngIf="data.input">
            <input matInput [type]="data.input_type" [(ngModel)]="data.input_name">
        </mat-form-field>
    </div>

    <div class="w-full flex flex-wrap justify-between actions_modal">
        <div class="block" [innerHtml]="data.question" routerLink="/auth/login"></div>
        <div class="flex flex-wrap justify-between gap-4">
            <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button>
            <button mat-button (click)="onNoClick()">Cancelar</button>
            <ng-container *ngIf="data.input; else elseInput">
                <button mat-button class="bg-[color:var(--primary-color)] text-white" [mat-dialog-close]="data.input_name">{{ data.name_btn ? data.name_btn : 'Guardar' }}</button>
            </ng-container>
            <ng-template #elseInput>
                <button mat-button (click)="accept()" class="bg-[color:var(--primary-color)] text-white">{{ data.name_btn ? data.name_btn : 'Aceptar' }}</button>
            </ng-template>
        </div>
    </div>
</div>